<template >
  <div class="loading_wrapper search" v-if="loading">
    <!-- <div>担当者の過去コメント情報の設定中です。<br>少々お待ち下さい。</div> -->
    <div class="circle"></div>
  </div>
  <div class="search-wrapper">
    <div class="search-entry">
      <div class="item-1">
        <div class="col">
          <label>会社ID</label>
          <input type="text" v-model="company_id">
        </div>
        <div class="col">
          <label>担当者名</label>
          <!-- <input type="text" v-model="manager"> -->
          <div class="manage_select_block">
            <select v-model="manager" id="sel_manager">  
              <option></option>
              <option v-for="mng in managers" :key="mng.index" :value="mng.userId">{{ mng.lastName }} {{mng.firstName}}</option>
            </select>
            <span>※過去コメントあり</span>
          </div>
          <div class="commetn_month">
             <input class="date-input" type="month" v-model="commetn_month">
             <span>コメント月</span>
           </div>
        </div>
        <div class="col">
          <label>エリア</label>
          <select v-model="area">
            <option v-for="area in areas" :key="area.index" :value="area.value">{{area.label}}</option>
          </select>
        </div>
        <div class="col">
          <label>マンション名</label>
          <input type="text" v-model="mansion">
        </div>
        <div class="col">
          <label>カナ</label>
          <input type="text" v-model="mannsixyonnmeikana">
          <span>※全角カナ</span>
        </div>
        <div class="col">
          <label>住所</label>
          <select v-model="prefecture_val">
            <option v-for="prefecture in prefectures" :key="prefecture.index">{{prefecture}}</option>
          </select>
        </div>
        <div class="col">
          <label>市区町村等</label>
          <input type="text" v-model="address">
        </div>
        <div class="col">
          <label>戸数</label>
          <input type="number" v-model="houses_num_from" min="1">
          <span>〜</span>
          <input type="number" v-model="houses_num_to" min="1">
        </div>
        <div class="col">
          <label>管理会社</label>
          <input type="text" v-model="management_company">
        </div>
      </div>
      <div class="item-2">
        <div class="col">
          <label>前回改修</label>
          <input class="date-input" type="month" v-model="repair_before_from">
          <span>〜</span>
          <input class="date-input" type="month" v-model="repair_before_to">
        </div>
        <div class="col">
          <label>営業予定</label>
          <input class="date-input" type="month" v-model="business_schedule_from">
          <span>〜</span>
          <input class="date-input" type="month" v-model="business_schedule_to">
        </div>
        <div class="col">
          <label>竣工日１</label>
          <input class="date-input" type="month" v-model="completion_date1_from">
          <span>〜</span>
          <input class="date-input" type="month" v-model="completion_date1_to">
        </div>
        <div class="col">
          <label>竣工日２</label>
          <input class="date-input" type="month" v-model="completion_date2_from">
          <span>〜</span>
          <input class="date-input" type="month" v-model="completion_date2_to">
        </div>
        <div class="col">
          <label>竣工日３</label>
          <input class="date-input" type="month" v-model="completion_date3_from">
          <span>〜</span>
          <input class="date-input" type="month" v-model="completion_date3_to">
        </div>
      </div>
      <div class="item-3">
        <div class="col">
          <label>営業状況</label>
          <input id="no_business" type="checkbox" v-model="no_business">
          <label for="no_business">営業予定なし</label>
          <input id="no_history" class="col-mrl" type="checkbox" v-model="no_history">
          <label for="no_history">営業履歴なし</label>
        </div>
        
        <div class="col">
          <label class="flag-label">各種フラグ</label>
          <div class="flex-wrap">
            <input type="checkbox" id="flag_lifeline" v-model="flag_lifeline">
            <label for="flag_lifeline">ライフライン物件</label>
            <input class="col-mrl" id="flag_hot" type="checkbox" v-model="flag_hot">
            <label for="flag_hot">ホット物件</label>
            <input id="flag_repeater" class="col-mrl" type="checkbox" v-model="flag_repeater">
            <label for="flag_repeater">リピート物件</label>
            <div class="indention"></div>
            <input id="flag_starmica" type="checkbox" v-model="flag_starmica">
            <label for="flag_starmica">議事録物件</label>
            <input id="flag_manbo" class="col-mrl" type="checkbox" v-model="flag_manbo">
            <label for="flag_manbo">マン暮物件</label>
            <input id="flag_days" class="col-mrl" type="checkbox" v-model="flag_days">
            <label for="flag_days">デイズ紹介物件</label>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <button class="search-btn" @click="getData(1, false)">検索</button>
        <button @click="dataClear()">項目クリア</button>
      </div>
    </div>
    <div class="search-result" id="search_result">
      <h2>検索結果</h2>
      <h3>{{ this.warning }}</h3>
      <div class="extract-table">
        <div class="search-result-head">
          <input type="checkbox" @change="checkAll()" v-model="all_checkbox_state">
          <span>全選択/解除</span>
          <p>{{(this.offset * 200) + 1}} - {{(this.offset * 200) + 200}}
 ／ 抽出件数{{this.data_total}}件</p>
        </div>

        <table>
          <thead>
            <tr>
              <th width="30px"></th>
              <th width="200px">ID</th>
              <th width="500px">マンション名</th>
              <th width="700px">住所</th>
            </tr>
          </thead>
          <tbody id="tbl_data_body">
            <tr v-for="data in extract_data" :key="data.index">
              <td width="30px"><input type="checkbox" :value="data.hs_object_id" v-model="select_data" @change="check(data.hs_object_id)"></td>
              <td width="200px">{{data.hs_object_id}}</td>
              <td width="500px">{{ this.dispMansion(data.name, data.mannsixyonnmeikana) }}</td>
              <td width="700px">{{ this.dispAddress(data) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div>
                  <button class="footer_button" @click="preview()">プレビュー/印刷</button>
                  <button class="footer_button" @click="outputCSV()">CSV出力</button>
                </div>
                <div class="pagination_wrapper">
                  <ul class="Pagination">
                    <li class="Pagination-Item">
                      <a class="Pagination-Item-Link" href="#" v-on:click.prevent="previous_page()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="Pagination-Item-Link-Icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                        </svg>
                      </a>
                    </li>
                  </ul>

                  <ul class="Pagination dynamic">
                    <li class="Pagination-Item" v-for="n in max_page" :key="n">
                      <a v-bind:class="this.paginationItemLink(n)" href="#" v-on:click.prevent="getData(n, true)"><span>{{ n }}</span></a>
                    </li>
                  </ul>

                  <ul class="Pagination">
                    <li class="Pagination-Item">
                      <a class="Pagination-Item-Link" href="#" v-on:click.prevent="next_page()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="Pagination-Item-Link-Icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import { API } from 'aws-amplify';
import Encoding from 'encoding-japanese';

const apiName = "KasiwabaraApp";
const path = "/companies";
const csvpath = "/prints";
const owner_path = "/owners";
const comidFormanage_path = "/getComidFormanage";

const get_formated_time = (
    _fmt = 'YYYYMMDDhhmmss',
    _dt  = new Date(),
) => [
        [ 'YYYY', _dt.getFullYear()  ],
        [ 'MM',   _dt.getMonth() + 1 ],
        [ 'DD',   _dt.getDate()      ],
        [ 'hh',   _dt.getHours()     ],
        [ 'mm',   _dt.getMinutes()   ],
        [ 'ss',   _dt.getSeconds()   ],
    ].reduce(
        (s,a) => s.replace( a[0], `${a[1]}`.padStart(a[0].length,'0') ),
        _fmt
    )

export default {
  name: 'SearchCompany',
  data() {
    return {
      // options

      areas: [
        {
          "label": "",
          "value": "",
          "displayOrder": 0,
          "hidden": false
        },
        {
          "label": "北海道営業所",
          "value": "北海道営業所",
          "displayOrder": 1,
          "hidden": false
        },
        {
          "label": "札幌営業所",
          "value": "札幌事務所",
          "displayOrder": 2,
          "hidden": false
        },
        {
          "label": "青森営業所",
          "value": "青森営業所",
          "displayOrder": 3,
          "hidden": false
        },
        {
          "label": "新潟営業所",
          "value": "新潟営業所",
          "displayOrder": 4,
          "hidden": false
        },
        {
          "label": "宮城営業所",
          "value": "宮城営業所",
          "displayOrder": 5,
          "hidden": false
        },
        {
          "label": "福島営業所",
          "value": "福島営業所",
          "displayOrder": 6,
          "hidden": false
        },
        {
          "label": "福井営業所",
          "value": "福井営業所",
          "displayOrder": 7,
          "hidden": false
        },
        {
          "label": "茨城営業所",
          "value": "茨城営業所",
          "displayOrder": 8,
          "hidden": false
        },
        {
          "label": "千葉南営業所",
          "value": "千葉営業所",
          "displayOrder": 9,
          "hidden": false
        },
        {
          "label": "千葉北営業所",
          "value": "東関東営業所",
          "displayOrder": 10,
          "hidden": false
        },
        {
          "label": "東京西営業所",
          "value": "西関東営業所",
          "displayOrder": 11,
          "hidden": false
        },
        {
          "label": "横浜営業所",
          "value": "南関東営業所",
          "displayOrder": 12,
          "hidden": false
        },
        {
          "label": "埼玉営業所",
          "value": "北関東営業所",
          "displayOrder": 13,
          "hidden": false
        },
        {
          "label": "東京営業所",
          "value": "東京営業所",
          "displayOrder": 14,
          "hidden": false
        },
        {
          "label": "神奈川営業所",
          "value": "神奈川営業所",
          "displayOrder": 15,
          "hidden": false
        },
        {
          "label": "名古屋営業所",
          "value": "名古屋営業所",
          "displayOrder": 16,
          "hidden": false
        },
        {
          "label": "三重営業所",
          "value": "三重営業所",
          "displayOrder": 17,
          "hidden": false
        },
        {
          "label": "京都営業所",
          "value": "京都営業所",
          "displayOrder": 18,
          "hidden": false
        },
        {
          "label": "大阪南営業所",
          "value": "大阪営業所",
          "displayOrder": 19,
          "hidden": false
        },
        {
          "label": "大阪北営業所",
          "value": "関西営業所",
          "displayOrder": 20,
          "hidden": false
        },
        {
          "label": "神戸営業所",
          "value": "神戸営業所",
          "displayOrder": 21,
          "hidden": false
        },
        {
          "label": "兵庫営業所",
          "value": "兵庫営業所",
          "displayOrder": 22,
          "hidden": false
        },
        {
          "label": "岡山営業所",
          "value": "岡山営業所",
          "displayOrder": 23,
          "hidden": false
        },
        {
          "label": "広島営業所",
          "value": "広島営業所",
          "displayOrder": 24,
          "hidden": false
        },
        {
          "label": "山口営業所",
          "value": "山口営業所",
          "displayOrder": 25,
          "hidden": false
        },
        {
          "label": "周南事務所",
          "value": "徳山出張所",
          "displayOrder": 26,
          "hidden": false
        },
        {
          "label": "愛媛営業所",
          "value": "愛媛営業所",
          "displayOrder": 27,
          "hidden": false
        },
        {
          "label": "福岡営業所",
          "value": "福岡営業所",
          "displayOrder": 28,
          "hidden": false
        },
        {
          "label": "北九州事務所",
          "value": "北九州事務所",
          "displayOrder": 29,
          "hidden": false
        },
        {
          "label": "大分営業所",
          "value": "大分営業所",
          "displayOrder": 30,
          "hidden": false
        },
        {
          "label": "鹿児島営業所",
          "value": "鹿児島営業所",
          "displayOrder": 31,
          "hidden": false
        },
        {
          "label": "沖縄営業所",
          "value": "沖縄営業所",
          "displayOrder": 32,
          "hidden": false
        },
        {
          "label": "山口事業部",
          "value": "山口事業部",
          "displayOrder": 33,
          "hidden": false
        },
        {
          "label": "東京東店",
          "value": "東京東店",
          "displayOrder": 34,
          "hidden": false
        },
        {
          "label": "山口東店",
          "value": "山口東店",
          "displayOrder": 35,
          "hidden": false
        },
        {
          "label": "山口西店",
          "value": "山口西店",
          "displayOrder": 36,
          "hidden": false
        },
        {
          "label": "首都圏事業部",
          "value": "首都圏事業部",
          "displayOrder": 37,
          "hidden": false
        },
        {
          "label": "地域戦略",
          "value": "地域戦略",
          "displayOrder": 38,
          "hidden": false
        },
        {
          "label": "賃貸小中規模セクション",
          "value": "賃貸小中規模セクション",
          "displayOrder": 39,
          "hidden": false
        },
        {
          "label": "ライフライン工事部",
          "value": "ライフライン工事部",
          "displayOrder": 40,
          "hidden": false
        }
      ],
      prefectures:
      [
        "","北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"
      ],
      // input or select value
      company_id: '',
      manager: '',
      area: '',
      mansion: '',
      mannsixyonnmeikana: '',
      prefecture_val: '',
      address: '',
      houses_num_from: '',
      houses_num_to: '',
      management_company: '',
      repair_before_from: '',
      repair_before_to: '',
      business_schedule_from: '',
      business_schedule_to: '',
      completion_date1_from: '',
      completion_date1_to: '',
      completion_date2_from: '',
      completion_date2_to: '',
      completion_date3_from: '',
      completion_date3_to: '',
      no_business: '',
      no_history: '',
      get_comment: '',
      comment_qty: '',
      flag_lifeline: false,
      flag_hot: false,
      flag_repeater: false,
      flag_starmica: false,
      flag_manbo: false,
      flag_days: false,
      all_checkbox_state: false,
      select_data:[],
      extract_data: [],
      input_data: [],
      companies_id: [],
      csv_data: [],
      warning: "",
      managers: [],
      loading: false,
      offset: 0,
      max_page: 0,
      data_total:0,
      id_array:[],
      commetn_month: ''

    }
  },
  components: {
    // VueLoading
  },
  async mounted() {
    document.title = "kchub";
    this.loading = true;
    await this.getOwners();
    this.loading = false;
  },
  methods: {
    // 検索
    async getData(pageno, paging) {
      this.loading = true;
      try{
        var element = document.getElementById("search_result");
        var rect = element.getBoundingClientRect();
        var elemtop = rect.top + window.scrollY;
        document.documentElement.scrollTop = elemtop;

        this.warning = ""
        this.select_data = []
        this.offset = (pageno - 1);
        // sessionStorage.clear()
        sessionStorage.removeItem('key'); 
        if (!paging) await this.getMaterials();
        this.setInputParameter();

        if (this.input_data.length == 0){
          this.warning = "検索条件を指定してください";
          this.extract_data = [];
          return;
        }

        let bodyparam = JSON.stringify({"parameters": this.input_data});
        let myInit = {
          headers: {"Content-Type": "application/json"},
          response: true,
          body: bodyparam
        }
        
        await API.get(apiName, (path + "?params=" + bodyparam), myInit).then(response => {
            let res  = JSON.parse(response.data.body);
            this.extract_data = res.data.CRM.company_collection.items;
            this.data_total = res.data.CRM.company_collection.total;
            this.max_page = Math.ceil(res.data.CRM.company_collection.total/200)
            // if (res.data.CRM.company_collection.total > 200){
            //   this.warning = "取得可能件数を超えています。（２００件まで可能）取得件数：" + res.data.CRM.company_collection.total + "件";
            // }
        }).catch(error => {
            console.log(error)
        });

      }finally{
        this.loading = false;
      }
      

    },
    async previous_page(){
      if (this.offset <= 0) return;
      this.getData((this.offset), true)
    },
    async next_page(){
      if (0 == this.max_page) return;
      if ((this.offset + 1) >= this.max_page) return;
      this.getData((this.offset + 2), true);
    },
    async getOwners(){

      if(!sessionStorage.getItem('owners')) {
        let myInit = {
          headers: {"Content-Type": "application/json"},
          response: true
        }
        await API.get(apiName, (owner_path), myInit).then(response => {
          let a = JSON.parse(response.data.body);
          let owners  = a.filter(body => body.lastName.length > 0);
          sessionStorage.setItem("owners", JSON.stringify(owners));
        }).catch(error => {
            console.log(error)
        });
      }
      this.managers = JSON.parse(
          sessionStorage.getItem('owners')
      );
    },
    setUsername(userId){
      let username = this.searchUserName(userId);
      return username;
    },
     searchUserName(id){
      let username = "";
      JSON.parse(sessionStorage.getItem('owners')).find((owner) => {
        if (owner["userId"] == id) {
          username = owner["lastName"] + owner["firstName"];
          return;
        }
      });
      return username;
    },
    //CSV出力
    async outputCSV(){
      if (this.select_data.length == 0 ) return;
      this.csv_data = [];

      let company_ids = [];
      try{
        // this.companies_id = this.select_data.join(',');
        this.loading = true;
        
        for (let index = 0; index < this.select_data.length; index++) {
          const id = this.select_data[index];
          company_ids.push(id);
          if (company_ids.length == 20) {
            await this.getCsvData(company_ids);
            company_ids = [];
          }
        }

        if (company_ids.length > 0){
          await this.getCsvData(company_ids);
        }

        await this.createCSV();
      } finally {
        this.loading = false;
      }
    },
    async getCsvData(company_ids){
      try{
        let myInit = {
          headers: {"Content-Type": "application/json"},
          response: true
        }
        let sort = (document.getElementById("sel_manager").value)? "notes_last_updated__desc": "hs_object_id__asc";

        await API.get(apiName, (csvpath + "?params=" + company_ids + "&sort=" + sort), myInit).then(response => {
            let res  = JSON.parse(response.data.body);
            res.data.CRM.company_collection.items.forEach(element => {
              this.csv_data.push(element);
            });

        }).catch(error => {
            console.log(error)
        });
      }catch{
        console.log("API Error")
      }
    },
    showEigyosho(data) {
      if(!data) return "";
      return data.label;
    },
    // CSV作成
    async createCSV(){
      const header = "会社ID,マンション名,郵便番号,都道府県,住所,担当営業所,竣工日,前回改修,階数,戸数,棟数,管理会社,理事長名,理事長部屋番号,修繕委員長名,修繕委員長部屋番号,総会月,ホット物件,ライフライン物件,リピート物件,議事録物件,マン暮物件,デイズ紹介物件,最新コメント日,最新コメント,最新コメント者,前回コメント日,前回コメント,前回コメント者 \n";
      let str = header;
      this.csv_data.forEach((val) => {
        str += val.hs_object_id + ",";    //会社ID
        str += val.name + ",";    //マンション名
        str += this.dis_zip(val.zip) + ",";    // 郵便番号
        str += val.state + ",";    // 都道府県
        str += val.adress + ",";    // 住所
        str += this.showEigyosho(val.tantoueigiyoushiyo) + ",";    // 担当営業所
        str += this.convertDate(val.shunkoubi1) + ",";    // 竣工日
        str += this.convertDate(val.zenkaikaishubi) + ",";    // 前回改修
        str += val.kaisuu + ",";    // 階数
        str += val.tosuu + ",";    // 戸数
        str += val.tousuu + ",";    // 棟数
        str += this.nullToEmpty(val.kanrigaisiya) + ",";    // 管理会社
        str += this.nullToEmpty(val.rijitixyoumei) + ",";    // 理事長名
        str += this.nullToEmpty(val.rijitixyouheyabangou) + ",";    // 理事長部屋番号
        str += this.nullToEmpty(val.siyuzeniintixyou) + ",";    // 修繕委員長名
        str += this.nullToEmpty(val.shuzeniinchoheyabangou )+ ",";    // 修繕委員長部屋番号
        str += this.dispSoukaiduki(val.soukaiduki) + ",";    // 総会月
        str += this.disp_boolean(val.hotbutukenkashiwabara) + ",";    // ホット物件
        str += this.disp_boolean(val.lifelinebutuken) + ",";    // ライフライン物件
        str += this.disp_boolean(val.repeat___n) + ",";    // リピート物件
        str += this.disp_boolean(val.starmaica) + ",";    // 議事録物件
        str += this.disp_boolean(val.manshiontokurasu) + ",";    // マン暮物件
        str += this.disp_boolean(val.dayssixyoukai) + ",";    // デイズ紹介物件
        val.associations.note_collection__company_to_note.items[0].forEach((note, index) => {
          if (index < 2){
            str += this.convertDate(note.hs_timestamp) + ",";    // 最新コメント日
            str += (!note.hs_body_preview)?",": "\""+note.hs_body_preview.replace(/\r?\n/g,'') + "\",";    // 最新コメント
            str += this.setUsername(note.hs_modified_by) + ",";    // 最新コメント者
          }
        });
        str += "\n"; //改行
      });
      let csv = "";
      csv = new Encoding.stringToCode(str)
      csv = Encoding.convert( csv, 'SJIS');
      csv = new Uint8Array( csv );

      var blob =new Blob([csv],{type:"text/csv"}); //配列に上記の文字列(str)を設定
      var link =document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download ="マンションデータ_" + get_formated_time() + ".csv";
      link.click();
    },
    async dataClear(){
      this.company_id = '',
      this.manager = '',
      this.area =  '',
      this.mansion = '',
      this.mannsixyonnmeikana = '',
      this.prefecture_val = '',
      this.address = '',
      this.houses_num_from = '',
      this.houses_num_to = '',
      this.management_company = '',
      this.repair_before_from = '',
      this.repair_before_to = '',
      this.business_schedule_from = '',
      this.business_schedule_to = '',
      this.completion_date1_from = '',
      this.completion_date1_to = '',
      this.completion_date2_from = '',
      this.completion_date2_to = '',
      this.completion_date3_from = '',
      this.completion_date3_to = '',
      this.no_business = '',
      this.no_history = '',
      this.get_comment = '',
      this.comment_qty= '',
      this.flag_lifeline = false,
      this.flag_hot = false,
      this.flag_repeater = false,
      this.flag_starmica = false,
      this.flag_manbo = false,
      this.flag_days = false,
      this.commetn_month = ""
    },
    async checkAll(){
      if(this.all_checkbox_state){
        this.select_data = []
        for (var data in this.extract_data){
          this.select_data.push(this.extract_data[data].hs_object_id)
        }
      }else{
        this.select_data = []
      }
    },
    async check(){
      if(this.select_data.length !== this.extract_data.length){
        this.all_checkbox_state = false
      }else{
        this.all_checkbox_state = true
      }
    },
    async preview(){
      if (this.select_data.length == 0 ) return;
      var message = this.select_data
      sessionStorage.setItem('key', JSON.stringify(message));
      window.open('printing', 'print_page', '_blank');
      // 親画面のセッションストレージ削除
      // sessionStorage.clear()
      sessionStorage.removeItem('key'); 

    },
    async excelOutput(){
      console.log("excel_output method")
    },
     dispMansion(name, kana){
      if (name == null) return kana;
      return name;
    },
    dispAddress(data){
      return this.nullToEmpty(data.state) + this.nullToEmpty(data.adress) + this.nullToEmpty(data.adres2);
    },
    convertDate(dt){
      if (dt === null) return "";
      return (new Date(dt)).toLocaleDateString('ja-JP');
    },
    dis_zip(zip){
      let rslt = this.nullToEmpty(zip);
      if (rslt == "") return "";
      if (rslt.indexOf("-") >= 0) {
        rslt = rslt.replace("-", "");
      }
      rslt = ("0000000" + rslt ).slice(-7);
      let start_num = rslt.substr(0,3);
      let end_num = rslt.substr(3);
      let zip_code =  start_num + '-' + end_num;
      return zip_code;
    },
    nullToEmpty(val){
      if (!val) return "";
      return val;
    },
    disp_boolean(flag){
      if (flag) {
        return "○";
      } else {
        return "";
      }
    },
    dispSoukaiduki(soukaiduki) {
      if (soukaiduki == null) return "";
      if (soukaiduki == "0") return "";
      return soukaiduki.includes("月")?soukaiduki:soukaiduki+"月";
    },
    paginationItemLink(n){
      return this.offset == (n-1)? "Pagination-Item-Link isActive": "Pagination-Item-Link"
    },
    getLastDate(yyyymm){
      let arr_ym = yyyymm.split("-");
      let yyyy = Number(arr_ym[0]);
      let mm = Number(arr_ym[1]);
      return new Date(yyyy, mm, 0).getTime();
    },
    async getMaterials(){
      this.id_array = [];
      if (this.manager == "") return;
      let myInit = {
          headers: {"Content-Type": "application/json"},
          response: true
      }
      this.id_array = [0];
      let hasmore = true;
      try{
        let lastmodifieddate__gte = "";
        let lastmodifieddate__lte = "";
        let lastmodifiedquery = "";

        if (this.commetn_month) {
          lastmodifieddate__gte = new Date(this.commetn_month + "-01").getTime();
          lastmodifieddate__lte = this.getLastDate(this.commetn_month);
          lastmodifiedquery = "&lastmodifieddate__gte=" + lastmodifieddate__gte + "&lastmodifieddate__lte=" + lastmodifieddate__lte
        }
        // APIで作成日の新着順で取得。
        // APIでMAX取得できる件数70件 × 9 = 630 × 10byte(idのバイト数) 
        // getメソッドで渡せる文字数制限に引っかかるため
        for (let index = 0; index < 8; index++) {
          await API.get(apiName, (comidFormanage_path + "?manager=" + this.manager + "&index=" + index + lastmodifiedquery), myInit).then(response => {
            hasmore = response.data.body.hasMore;
            this.id_array.push(...response.data.body.id);
          });
          if ( !hasmore ) break;
        }
      }finally{
        // 重複分をまとめる
        this.id_array = new Set(this.id_array);
        // Set型をArrayへ変換
        this.id_array = Array.from(this.id_array);
      }
    },
    async setInputParameter(){
      this.input_data = [];
      if (this.company_id != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"string","property_name":"hs_object_id","property_value":this.company_id}} );
      }
      if (this.offset != "") {
        this.input_data.push( {"type":"offset","params":this.offset} );
      }

      if (this.manager != "") {
        this.input_data.push( {"type":"manager","params":this.manager} );
      }
      if (this.id_array.length > 0){
        this.input_data.push( {"type":"id_array","params":this.id_array} );
      }
      if (this.area != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"string","property_name":"tantoueigiyoushiyo","property_value":this.area}} ); 

      }
      if (this.mansion != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__contains","fieldType":"string","property_name":"name","property_value":this.mansion}} ); 
        
      }
      if (this.mannsixyonnmeikana != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"string","property_name":"mannsixyonnmeikana","property_value":this.mannsixyonnmeikana}} ); 
        
      }
      if (this.prefecture_val != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"string","property_name":"state","property_value":this.prefecture_val}} ); 
        
      }
      if (this.address != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__contains","fieldType":"string","property_name":"adress","property_value":this.address}} ); 
        
      }
      if (this.houses_num_from != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__gte","fieldType":"number","property_name":"tosuu","property_value":this.houses_num_from}} ); 
        
      }
      if (this.houses_num_to != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__lte","fieldType":"number","property_name":"tosuu","property_value":this.houses_num_to}} ); 
        
      }
      if (this.management_company != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__contains","fieldType":"string","property_name":"kanrigaisiya","property_value":this.management_company}} ); 
        
      }
      let dt;
      if (this.repair_before_from != "") {
        dt = new Date(this.repair_before_from + "-01").getTime();
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__gte","fieldType":"datetime","property_name":"zenkaikaishubi","property_value":dt}} ); 
        
      }
      if (this.repair_before_to != "") {
        dt = this.getLastDate(this.repair_before_to);
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__lte","fieldType":"datetime","property_name":"zenkaikaishubi","property_value":dt}} ); 
        
      }
      if (this.business_schedule_from != "") {
        dt = new Date(this.business_schedule_from + "-01").getTime();
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__gte","fieldType":"datetime","property_name":"eigiyouteikashiwabara","property_value":dt}} ); 
        
      }
      if (this.business_schedule_to != "") {
        dt = this.getLastDate(this.business_schedule_to);
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__lte","fieldType":"datetime","property_name":"eigiyouteikashiwabara","property_value":dt}} ); 
        
      }
      if (this.no_business != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__null","fieldType":"boolean","property_name":"num_notes","property_value":true}} ); 
        
      }
      if (this.no_history != "") {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__null","fieldType":"boolean","property_name":"eigiyouteikashiwabara","property_value":true}} ); 
        
      }
      // if (this.get_comment != "") {
      //   this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"string","property_name":"hs_modified_by","property_value":this.manager}} ); 
        
      // }
      // if (this.comment_qty != "") {
      //   this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"number","property_name":"hs_modified_by","property_value":this.manager}} ); 
        
      // }
      if (this.flag_repeater) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"repeat___n","property_value":true}} ); 
        
      }
      if (this.flag_starmica) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"starmaica","property_value":true}} ); 
        
      }
      if (this.flag_manbo) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"manshiontokurasu","property_value":true}} ); 
        
      }
      if (this.flag_days) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"dayssixyoukai","property_value":true}} ); 
        
      }
      if (this.flag_lifeline) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"lifelinebutuken","property_value":true}} ); 
        
      }
      if (this.flag_hot) {
        this.input_data.push( {"type":"and","range":false,"params":{"operate":"__eq","fieldType":"boolean","property_name":"hotbutukenkashiwabara","property_value":true}} ); 
        
      }

      //OR条件
      if (this.completion_date1_from != "" || this.completion_date1_to != "" || this.completion_date2_from != "" || this.completion_date2_to != "" || this.completion_date3_to != ""){
        let dic_completion_date = [];
        let date1_arr = [];

        if (this.completion_date1_from != "" || this.completion_date1_to != "") {
          if (this.completion_date1_from != "") {
            dt = new Date(this.completion_date1_from + "-01").getTime();
            date1_arr.push({
              "operate": "__gte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
            
          }
          if (this.completion_date1_to != "") {
            dt = this.getLastDate(this.completion_date1_to);
            date1_arr.push({
              "operate": "__lte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
          }
          dic_completion_date.push({
                    "range": true,
                    "params": date1_arr
                  });
        }
        if (this.completion_date2_from != "" || this.completion_date2_to != "") {
          date1_arr = [];
          if (this.completion_date2_from != "") {
            dt = new Date(this.completion_date2_from + "-01").getTime();
            date1_arr.push({
              "operate": "__gte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
            
          }
          if (this.completion_date2_to != "") {
            dt = this.getLastDate(this.completion_date2_to);
            date1_arr.push({
              "operate": "__lte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
          }
          dic_completion_date.push({
                    "range": true,
                    "params": date1_arr
                  });
        }
        if (this.completion_date3_from != "" || this.completion_date3_to != "") {
          date1_arr = [];
          if (this.completion_date3_from != "") {
            dt = new Date(this.completion_date3_from + "-01").getTime();
            date1_arr.push({
              "operate": "__gte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
            
          }
          if (this.completion_date3_to != "") {
            dt = this.getLastDate(this.completion_date3_to);
            date1_arr.push({
              "operate": "__lte",
              "fieldType": "datetime",
              "property_name": "shunkoubi1",
              "property_value": dt
            });
          }
          dic_completion_date.push({
                    "range": true,
                    "params": date1_arr
                  });
        }

        if (dic_completion_date.length > 0)
        {
          this.input_data.push({"type": "or", "params": dic_completion_date});
        }
      }
      //OR条件
    }
  },
  beforeUnmount() {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 5px;
}
a {
  color: #42b983;
  text-decoration: none;
}

button:hover{
  cursor: pointer;
}
.search-wrapper{
  margin-top: 3vh;
}
.search-entry,
.search-result,
.search-result .btn-wrapper{
  min-width: 1000px;
}

.search-entry{
  background-color: var(--amplify-colors-teal-10);
  border-radius: 8px;
  width: 70%;
  margin: 0 auto 3em;
  padding: 3vh 3vh 3vh 3vh;
}

.item-1,
.item-2{
  display: inline-block;
  vertical-align: top;
}

.item-3,
.btn-wrapper{
  display: inline-block;
}

.item-1{
  width: 50%;
}

.item-2{
  width: 50%;
}

.item-3{
  width:70%;
}

.item-1 label,
.item-1 select{
  width: 171px;
}

.search-entry .btn-wrapper{
  width: 30%;
  vertical-align: bottom;
}

.search-entry .btn-wrapper button{
  width: 7em;
}

.item-2 .col label{
  min-width: unset;
}

.item-3 .col{
  margin: 0;
}

.item-3 .col label{
  flex-basis: 15%;
}

.item-3 .col .flag-label{
  flex-basis: 18.5%;
}

.col{
  display: flex;
  align-items: center;
  margin: 1vh 0;
  text-align: left;
}

.col label{
  flex-basis: 25%;
  min-width: 130px;
}

.col select,
.col input{
  flex-basis: auto;
  height: 32px;
}

.col span,
.search-result .btn-wrapper span{
  font-size: 14px;
  margin: 0 1em;
}

.col .flex-wrap{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.indention{
  width: 100%;
}

.col-mrl{
  margin-left: 3em;
}

.col-mlr{
  margin-right: 1em;
}

.date-input{
  /* width: 40%; */
}

.search-btn{
  margin-right: 2em;
}

.search-result .btn-wrapper{
  margin: 3em auto;
  text-align: left;
}

.search-result .btn-wrapper button:nth-child(1){
  margin-right: 2em;
}

/* .search-result-head, */
.extract-table,
.search-result .btn-wrapper{
  width: 95%;
}

.search-result-head{
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.search-result-head p{
  margin-left: auto;
}

.extract-table{
  margin: 0 auto;
  padding: 1vh;
  min-width: 1000px;
  /* height: 500px; */
  /* border: 2px solid; */
  width: fit-content;
}

.extract-table table{
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  overflow: scroll;
}

.extract-table tr{
  height: 3em;
}

.extract-table tr:nth-child(odd){
  background-color: var(--amplify-colors-neutral-20);
}

thead, tbody {
  display: block;
}
tbody {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 600px;
}
tfoot {
  text-align: left;
}
tfoot td {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}
button{
  margin-left: 10px;
  margin-right: 10px;
  width: 150px;
  height: 35px;

}
.loading_wrapper{
  position: absolute;
  height: 170vh;
  width: 100vw;
  background: black;
  opacity: 0.33;  
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.circle{
  width:100px;
  height:100px;
  border-radius:150px;
  border:15px solid #fff;
  border-top-color:rgba(0,0,0,0.3);
  box-sizing:border-box;
  position:absolute;

  animation:circle 1s linear infinite;
  -webkit-animation:circle 1s linear infinite;
}
@keyframes circle{
  0%{transform:rotate(0deg)}
  100%{transform:rotate(360deg)}
}
@-webkit-keyframes circle{
  0%{-webkit-transform:rotate(0deg)}
  100%{-webkit-transform:rotate(360deg)}
}

.pagination_wrapper{
  display: flex;
}
.Pagination {
display: flex;
align-items: center;
}
.dynamic{
  max-width: 946px;
  overflow: scroll;
}

.Pagination-Item-Link {
width: 30px;
height: 30px;
border-radius: 5px;
display: flex;
justify-content: center;
align-items: center;
flex-wrap: wrap;
overflow: hidden;
background: transparent;
border: solid 1px #2c3e50;
/* font-size: 12px; */
color: #2c3e50;
/* font-weight: bold; */
transition: all 0.15s linear;
}
.Pagination-Item-Link-Icon {
width: 20px;
}
.Pagination-Item-Link.isActive {
background: #2c3e50;
color: #fff;
pointer-events: none;
}
.Pagination-Item-Link:not(.isActive):hover {
background: #2c3e50;
color: #fff;
}
.Pagination > * + * {
margin-left: 8px;
}
.manage_select_block {
   display: flex;
   flex-direction: column;
   flex-wrap: nowrap;
   justify-content: center;
   align-items: flex-start;
 }
 .commetn_month{
   margin-left: 1em;
   display: flex;
   flex-direction: column;
   flex-wrap: nowrap;
   justify-content: center;
   align-items: flex-start;
 }
</style>